// extracted by mini-css-extract-plugin
export default {"thumbnail":"VideoThumbnail_thumbnail__iQTsn","videoIcon":"VideoThumbnail_videoIcon__Ux3Uf"};